import { render, staticRenderFns } from "./UserIconLarge.vue?vue&type=template&id=22a7c0fc&scoped=true&"
import script from "./UserIconLarge.vue?vue&type=script&lang=js&"
export * from "./UserIconLarge.vue?vue&type=script&lang=js&"
import style0 from "./UserIconLarge.vue?vue&type=style&index=0&id=22a7c0fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a7c0fc",
  null
  
)

export default component.exports